var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$root.user.active
      ? _c(
          "div",
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._l(_vm.phoneNumbers, function(number, index) {
              return number.active == 1
                ? _c(
                    "div",
                    { staticClass: "row row-single setting outgoing-number" },
                    [
                      _vm.$root.app.platform == "android"
                        ? _c(
                            "div",
                            {
                              staticClass: "col col-100",
                              class: {
                                "validation-error":
                                  _vm.$v.phoneNumbers.$each.$error
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: number.name,
                                    expression: "number.name"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: { value: number.name },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        number,
                                        "name",
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      return _vm.$v.phoneNumbers.$touch()
                                    }
                                  ]
                                }
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(number.phoneNumber) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$root.app.platform == "ios"
                        ? _c(
                            "div",
                            {
                              staticClass: "col col-50",
                              class: {
                                "validation-error":
                                  _vm.$v.phoneNumbers.$each.$error
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: number.name,
                                    expression: "number.name"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: { value: number.name },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        number,
                                        "name",
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      return _vm.$v.phoneNumbers.$touch()
                                    }
                                  ]
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$root.app.platform == "ios"
                        ? _c("div", { staticClass: "col col-50" }, [
                            _c("span", { staticClass: "row__subtitle" }, [
                              _vm._v(_vm._s(number.phoneNumber))
                            ])
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _vm.$root.app.platform == "ios"
              ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
              : _vm._e(),
            _vm._v(" "),
            Object.keys(this.phoneNumbers).length > 1
              ? _c(
                  "div",
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._l(_vm.phoneNumbers, function(number, index) {
                      return number.active == 0
                        ? _c(
                            "div",
                            { staticClass: "row setting row-list-item" },
                            [
                              _vm.$root.app.platform == "android"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "col col-100",
                                      class: {
                                        "validation-error":
                                          _vm.$v.phoneNumbers.$each.$error
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: number.name,
                                            expression: "number.name"
                                          }
                                        ],
                                        attrs: { type: "text" },
                                        domProps: { value: number.name },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                number,
                                                "name",
                                                $event.target.value
                                              )
                                            },
                                            function($event) {
                                              return _vm.$v.phoneNumbers.$touch()
                                            }
                                          ]
                                        }
                                      }),
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(number.phoneNumber) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$root.app.platform == "ios"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "col col-50",
                                      class: {
                                        "validation-error":
                                          _vm.$v.phoneNumbers.$each.$error
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: number.name,
                                            expression: "number.name"
                                          }
                                        ],
                                        attrs: { type: "text" },
                                        domProps: { value: number.name },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                number,
                                                "name",
                                                $event.target.value
                                              )
                                            },
                                            function($event) {
                                              return _vm.$v.phoneNumbers.$touch()
                                            }
                                          ]
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$root.app.platform == "ios"
                                ? _c("div", { staticClass: "col col-50" }, [
                                    _c(
                                      "span",
                                      { staticClass: "row__subtitle" },
                                      [_vm._v(_vm._s(number.phoneNumber))]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              : _vm._e()
          ],
          2
        )
      : _c("div", [_vm._m(3)]),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row row-button" }, [
      _c("div", { staticClass: "col col-100" }, [
        _c("button", { staticClass: "button", on: { click: _vm.editInfo } }, [
          _vm._v("Gegevens opslaan")
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row setting row-last explanation" }, [
      _c("div", [
        _c("div", [
          _vm._v(
            "\n                        Pas hier de nummer instellingen aan.\n                    "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Huidig nummer")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Overige nummers")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row setting notice" }, [
      _c("div", { staticClass: "col col-100" }, [
        _c("b", [_vm._v("Inactief account")]),
        _c("br"),
        _vm._v(
          " \n                    Uw abonnement is verlopen. Wilt u een nieuw abonnement? Neem dan contact op met onze helpdesk via 'Ondersteuning'.\n                "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a38e96c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a38e96c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Numbers.vue
// module id = null
// module chunks = 